import { useMemo } from 'react';
import { StrapiLandingBaseModel } from 'strapi/types';

type ColorGroup = {
  name: string;
  colors: StrapiLandingBaseModel[];
};

const useFilterData = (colorPages: StrapiLandingBaseModel[]) => {
  const mergeItems = (items: ColorGroup[]) => {
    const mergedMap = new Map();

    items.forEach(item => {
      if (mergedMap.has(item.name)) {
        mergedMap.get(item.name)?.colors.push(...item.colors);
      } else {
        mergedMap.set(item.name, { ...item });
      }
    });
    return Array.from(mergedMap.values());
  };

  const filterData: ColorGroup[] = useMemo(() => {
    const modifiedData: ColorGroup[] = [];
    colorPages.map((item: StrapiLandingBaseModel, index: number) => {
      const realIndex = index === 0 ? index : index - 1;
      if (modifiedData[realIndex]?.name === item.colorData.category) {
        modifiedData[realIndex].colors.push(item);
      } else {
        modifiedData.push({
          name: item.colorData.category,
          colors: [item],
        });
      }
      return modifiedData;
    });
    return mergeItems(modifiedData);
  }, [colorPages]);

  return { filterData };
};

export default useFilterData;
